import { Navigate } from "react-router";

import { useUserRole } from "@utils/hooks/useUserRole";

import { routes } from "@pages/routes";

interface AdminRouteGuardProps {
  children: React.ReactNode;
}

export const AdminRouteGuard = ({ children }: AdminRouteGuardProps) => {
  const { hasAffireAdminRole, isLoading } = useUserRole();

  if (isLoading) {
    return null;
  }

  if (!hasAffireAdminRole()) {
    return <Navigate to={routes.portal.dashboard.$path()} replace />;
  }

  return <>{children}</>;
};